<template>  
  <v-container fluid grid-list-lg class="ma-0 pa-0">
    <v-card>
      <v-toolbar dark dense flat :color="fm.jilid_id ? (jilids.find(x=>x.id===fm.jilid_id) ? jilids.find(x=>x.id===fm.jilid_id).color : 'cyan') :'cyan'">
        <v-toolbar-title>Report Surveyor</v-toolbar-title>        
      </v-toolbar>
      <v-divider/>
      <v-card-text>
        <v-layout row>
          <v-flex xs6 md3>
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.surveyor_id"
              label="Search Surveyor"
              :items="surveyors"
              item-text="username"
              item-value="id"
              :loading="surveyorLoading"        
              style="background:#fff;"
              autocomplete="off"
              @keyup="searchSurveyor"
            >
              <template v-slot:item="data">                
                <template>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.username"></v-list-item-title>
                    <v-list-item-subtitle>{{ data.item.name }} <small>{{data.item.phone}}</small></v-list-item-subtitle>                    
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>        
          </v-flex>
          <v-flex xs6 md2>
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.jilid_id"
              label="Jilid"
              :items="jilids"
              item-text="name"
              item-value="id"
              :loading="jilidLoading"        
              style="background:#fff; max-width:250px"
              autocomplete="off"
            />        
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider v-if="user && user.id" />
      <v-card-text v-if="user && user.id">
        <v-layout row>
          <v-flex xs12 md4>
            <v-card>
              <v-img height="170" src="@/app/assets/cover.jpg">
                <v-layout column align-center justify-center class="pt-3">
                  <v-progress-circular
                    v-if="loading"
                    :size="100"
                    :width="8"
                    color="info"
                    indeterminate
                    class="mt-4"
                  ></v-progress-circular>            
                  <v-avatar v-if="!loading" size="100" class="mt-4 mb-4" :color="'pink'">              
                    <img v-if="user && user.thumbFileBase64" :src="user.thumbFileBase64" >
                    <span v-else class="white--text display-3">{{firstLetter(user ? user.username:null)}}</span>  
                  </v-avatar>            
                  <h1 class="white--text">{{user ? user.username:null}}</h1>                        
                </v-layout>                                               
              </v-img>            
              <v-card-text class="pa-0">                                     
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Fullname</v-list-item-subtitle>
                    <v-list-item-title>{{ user.name }}</v-list-item-title>                      
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Email</v-list-item-subtitle>
                    <v-list-item-title>{{ user.email }}</v-list-item-title>                      
                  </v-list-item-content>
                </v-list-item>                  
                <v-divider />
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Phone</v-list-item-subtitle>
                    <v-list-item-title>{{ user.phone }}</v-list-item-title>                      
                  </v-list-item-content>
                </v-list-item>                  
                <v-divider />                                                      
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md8 v-if="fm.jilid_id">
            <v-layout row>
              <v-flex xs6 md3 lg3 v-if="!disabled.addr_idkab">
                <v-autocomplete outlined dense hide-no-data hide-details
                  v-model="sebaran.idpro"
                  label="Provinsi"
                  :items="provinsi"
                  item-text="name"
                  item-value="id"
                  :loading="provinsiLoading"
                  :disabled="disabled.idpro"
                  clearable
                  autocomplete="off"
                />
              </v-flex>
              <v-flex xs6 md3 lg3>  
                <v-autocomplete outlined dense hide-no-data hide-details
                  v-model="sebaran.idkab"
                  label="Kabupaten/Kota"
                  :items="kabupaten"
                  item-text="name"
                  item-value="id"
                  :loading="kabupatenLoading"
                  :disabled="disabled.idkab"
                  clearable autocomplete="off"
                />
              </v-flex>
              <v-flex xs6 md3 lg3>  
                <v-autocomplete outlined dense hide-no-data hide-details
                  v-model="sebaran.idkec"
                  label="Kecamatan"
                  :items="kecamatan"
                  item-text="name"
                  item-value="id"
                  :loading="kecamatanLoading"
                  :disabled="disabled.idkec"
                  clearable autocomplete="off"
                />
              </v-flex>
              <v-flex xs6 md3 lg3>  
                <v-autocomplete outlined dense hide-no-data hide-details
                  v-model="sebaran.idkel"
                  label="Kelurahan"
                  :items="kelurahan"
                  item-text="name"
                  item-value="id"
                  :loading="kelurahanLoading"
                  :disabled="disabled.idkel"
                  clearable autocomplete="off"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <template v-if="surveyLoading">
                  <v-card>
                    <v-skeleton-loader                
                      style="width:100%"
                      type="article, date-picker"
                    ></v-skeleton-loader>
                  </v-card>
                </template>
                <template v-else>
                  <v-layout row v-if="sebaran.idkec">              
                    <v-flex xs12>
                      <v-card :set="area = kecamatan.find(x=>x.id==sebaran.idkec)">
                        <v-card-text v-if="area">      
                          <v-layout row class="pa-3">              
                            <v-progress-circular
                              :rotate="360"
                              :size="100"
                              :width="10"
                              :value="parseInt(parseInt(area.lembarDone)/parseInt(area.lembar)*100)"
                              :color="color"
                              class="mr-4"
                            >
                              <span class="title">{{ area.lembarDone }}/{{area.lembar}}</span>
                            </v-progress-circular>
                            <v-flex>
                              <h3>{{ area.name }}</h3>
                              <h5>{{ area.parent_name }}</h5>
                              <h1 class="mt-3">{{ parseFloat(parseInt(area.lembarDone)/parseInt(area.lembar)*100).toFixed(1) }}%</h1>
                            </v-flex>
                          </v-layout>  
                        </v-card-text>                  
                      </v-card>
                    </v-flex>
                    <v-flex md2 xs4 v-for="(item, i) in kelurahan" :key="i">
                      <v-card>
                        <v-card-text class="pa-0 pt-2 text-center">                    
                          <v-progress-circular
                            :rotate="360"
                            :size="100"
                            :width="10"
                            :value="parseInt(parseInt(item.lembarDone)/parseInt(item.lembar)*100)"
                            :color="color"
                          >
                            {{ item.lembarDone }}/{{item.lembar}}
                          </v-progress-circular>
                          <v-toolbar-title class="caption">{{item.name}}</v-toolbar-title>
                        </v-card-text>                  
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-else-if="sebaran.idkab">
                    <v-flex xs12>
                      <v-card :set="area = kabupaten.find(x=>x.id==sebaran.idkab)">
                        <v-card-text  v-if="area">      
                          <v-layout row class="pa-3">              
                            <v-progress-circular
                              :rotate="360"
                              :size="100"
                              :width="10"
                              :value="parseInt(parseInt(area.lembarDone)/parseInt(area.lembar)*100)"
                              :color="color"
                              class="mr-4"
                            >
                              <span class="title">{{ area.lembarDone }}/{{area.lembar}}</span>
                            </v-progress-circular>
                            <v-flex>
                              <h3>{{ area.name }}</h3>
                              <h5>{{ area.parent_name }}</h5>
                              <h1 class="mt-3">{{ parseFloat(parseInt(area.lembarDone)/parseInt(area.lembar)*100).toFixed(1) }}%</h1>
                            </v-flex>
                          </v-layout>  
                        </v-card-text>                  
                      </v-card>
                    </v-flex>
                    <v-flex md2 xs4 v-for="(item, i) in kecamatan" :key="i">
                      <v-card>
                        <v-card-text class="pa-0 pt-2 text-center">                    
                          <v-progress-circular
                            :rotate="360"
                            :size="100"
                            :width="10"
                            :value="parseInt(parseInt(item.lembarDone)/parseInt(item.lembar)*100)"
                            :color="color"
                          >
                            {{ item.lembarDone }}/{{item.lembar}}
                          </v-progress-circular>
                          <v-toolbar-title class="caption">{{item.name}}</v-toolbar-title>
                        </v-card-text>                  
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-else-if="sebaran.idpro">
                    <v-flex xs12>
                      <v-card :set="area = provinsi.find(x=>x.id==sebaran.idpro)">
                        <v-card-text  v-if="area">      
                          <v-layout row  class="pa-3">              
                            <v-progress-circular
                              :rotate="360"
                              :size="100"
                              :width="10"
                              :value="parseInt(parseInt(area.lembarDone)/parseInt(area.lembar)*100)"
                              :color="color"
                              class="mr-4"
                            >
                              <span class="title">{{ area.lembarDone }}/{{area.lembar}}</span>
                            </v-progress-circular>
                            <v-flex>
                              <h3>{{ area.name }}</h3>
                              <h5>{{ area.parent_name }}</h5>
                              <h1 class="mt-3">{{ parseFloat(parseInt(area.lembarDone)/parseInt(area.lembar)*100).toFixed(1) }}%</h1>
                            </v-flex>
                          </v-layout>  
                        </v-card-text>                  
                      </v-card>
                    </v-flex>              
                    <v-flex md2 xs4 v-for="(item, i) in kabupaten" :key="i">
                      <v-card>
                        <v-card-text class="pa-0 pt-2 text-center">                    
                          <v-progress-circular
                            :rotate="360"
                            :size="100"
                            :width="10"
                            :value="parseInt(parseInt(item.lembarDone)/parseInt(item.lembar)*100)"
                            :color="color"
                          >
                            {{ item.lembarDone }}/{{item.lembar}}
                          </v-progress-circular>
                          <v-toolbar-title class="caption">{{item.name}}</v-toolbar-title>
                        </v-card-text>                  
                      </v-card>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>                                  
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>  
      <v-divider/>
      <v-card-text>      
        <v-layout row>
          <v-flex xs12 md2>
            <v-text-field flat dense filled
              v-model="term"
              append-icon="search"
              label="Search"
              single-line
              hide-details        
              @input="search"
              style="max-width:250px"              
            ></v-text-field>                       
          </v-flex>
          <v-flex xs12 md3>
            <v-radio-group v-model="fm.type" label="Answer Type :" class="mt-0" hide-details row>
              <v-radio label="id" :value="1"></v-radio>
              <v-radio label="key" :value="2"></v-radio>
              <v-radio label="value" :value="3"></v-radio>                                        
            </v-radio-group>
          </v-flex>
          <v-flex xs6 md2>
            <v-checkbox v-model="fm.alamat" label="alamat" class="mt-0" hide-details />            
          </v-flex>
          <v-flex xs6 md1>
            <v-btn color="success" dark @click="export2excel()">
              <v-icon left>select_all</v-icon>.xls
            </v-btn>
          </v-flex>
        </v-layout>        
      </v-card-text>
      <v-card-text>      
        <v-container fluid grid-list-lg class="ma-0 pa-0">
          <v-layout row>
            <v-flex xs12>
              <v-progress-linear
                v-if="loadstart"
                v-model="persen"
                height="25"
                reactive
                color="green"
                stream striped                
              >
                <strong>load data {{ Math.ceil(persen) }}%</strong>
              </v-progress-linear>
              <v-skeleton-loader  v-if="loading"         
                type="card, actions"
                style="width:100%"
              ></v-skeleton-loader>
            </v-flex>
            <template  v-if="persen > 0">
              <v-flex xs12>
                <v-card flat v-if="place">
                  <v-responsive :aspect-ratio="16/5">
                    <GmapMap
                      :center="place"
                      :zoom="11"                    
                      map-type-id="hybrid"
                      style="width: 100%; height: 100%"                     
                    >
                      <template v-for="(respon, i ) in items">
                        <Gmap-Marker :key="i"
                          v-if="respon.geom && respon.geom.coordinates && respon.geom.coordinates[0]"                                              
                          :position="{lat:parseFloat(respon.geom.coordinates[0]),lng:parseFloat(respon.geom.coordinates[1])}"                                                
                        >                    
                        </Gmap-Marker>
                      </template>                    
                    </GmapMap>
                  </v-responsive>
                </v-card>                              
              </v-flex>
              <v-flex xs12  class="v-data-table__wrapper" style="position:relative; overflow-x: auto;" id="export">              
                <table class="tb-normal">
                  <thead>
                    <tr>
                      <th rowspan="2">No</th>
                      <th rowspan="2">Code</th>
                      <th rowspan="2">Date</th>
                      <th rowspan="2">Name</th>
                      <th rowspan="2">G</th>
                      <th rowspan="2">Phone</th>
                      <template v-if="fm.alamat">
                        <th rowspan="2">Address</th>
                        <th rowspan="2">Propinsi</th>
                        <th rowspan="2">Kabupaten</th>
                        <th rowspan="2">Kecamatan</th>
                        <th rowspan="2">Kelurahan</th>
                        <th rowspan="2">Tps</th>
                      </template>
                      <th :colspan="items[0] && items[0].responDtls ? items[0].responDtls.length : 0">Pertanyaan</th>
                      <th rowspan="2" style="min-width:130px">Created at</th>
                      <th rowspan="2">isOnline</th>
                      <th rowspan="2">Lat Lng</th>
                    </tr>
                    <tr v-if="items[0] && items[0].responDtls">
                      <th v-for="(item,i) in items[0].responDtls" :key="i">
                        {{item.no}}                    
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(respon, i ) in items">
                      <tr :key="i">
                        <td valign="top">{{i+1}}</td>
                        <td valign="top">{{respon.code}}</td>
                        <td valign="top">{{respon.date}}</td>
                        <td valign="top">{{respon.name}}</td>
                        <td valign="top">{{respon.gender}}</td>
                        <td valign="top">{{respon.phone}}</td>
                        <template v-if="fm.alamat">
                          <td valign="top">{{respon.address}}</td>
                          <td valign="top">{{respon.propinsi ? respon.propinsi.name : respon.addr_idpro}}</td>
                          <td valign="top">{{respon.kabupaten ? respon.kabupaten.name : respon.addr_idkab}}</td>
                          <td valign="top">{{respon.kecamatan ? respon.kecamatan.name : respon.addr_idkec}}</td>
                          <td valign="top">{{respon.kelurahan ? respon.kelurahan.name : respon.addr_idkel}}</td>
                          <td valign="top">{{respon.tps ? respon.tps.name : respon.tps_id}}</td>
                        </template>  
                        <template v-for="(item, j) in respon.responDtls">
                          <td :key="j" valign="top">
                            <template v-if="fm.type===1">
                              <span v-if="item.type === 1">{{item.answer_id}}</span>
                              <span v-if="item.type === 2">                          
                                <span v-for="(ans, k) in item.answer_jsonid" :key="k" v-if="ans">
                                  {{ans}},
                                </span>
                              </span>                            
                            </template>
                            <template v-if="fm.type===2">
                              <span v-if="item.type === 1">{{item.option.find(x=>x.id===item.answer_id) ? item.option.find(x=>x.id===item.answer_id).key : ''}}</span>
                              <span v-if="item.type === 2">                          
                                <span v-for="(ans, k) in item.answer_jsonid" :key="k" v-if="ans">
                                  {{item.option.find(x=>x.id===ans) ? item.option.find(x=>x.id===ans).key : ''}},
                                </span>
                              </span>
                            </template>
                            <template v-if="fm.type===3">
                              <span v-if="item.type === 1">{{item.option.find(x=>x.id===item.answer_id) ? item.option.find(x=>x.id===item.answer_id).value : ''}}</span>
                              <span v-if="item.type === 2">                          
                                <span v-for="(ans, k) in item.answer_jsonid" :key="k" v-if="ans">
                                  {{item.option.find(x=>x.id===ans) ? item.option.find(x=>x.id===ans).value :''}},
                                </span>
                              </span>
                            </template>
                            <template v-if="fm.type===2">
                              <span v-if="item.type === 1">{{item.answer_value}}</span>
                              <span v-if="item.type === 2">                          
                                <span v-for="(ans, k) in item.answer_jsonvalue" :key="k" v-if="ans">
                                  {{ans}},
                                </span>
                              </span>
                            </template>
                            <span v-if="item.type === 3">
                              <span v-for="(ans, k) in item.answer_jsonvalue" :key="k" v-if="ans">
                                {{ans}},
                              </span>
                            </span>  
                          </td>
                        </template>
                        <td valign="top">{{$moment(respon.created_at*1000).format('DD-MM-YYYY HH:mm')}}</td>
                        <td valign="top">{{respon.client_id ? 'offline':'online'}}</td>
                        <td valign="top"><a target="_blank" :href="'https://www.google.com/maps/search/?api=1&amp;query='+respon.geom.coordinates[0]+','+respon.geom.coordinates[1]" v-if="respon.geom && respon.geom.coordinates && respon.geom.coordinates[0]">{{respon.geom.coordinates}}</a></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </v-flex> 
            </template>               
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card> 
  </v-container>  
</template>

<script>
import { debounce } from 'lodash'
import Model from '@/app/models/Report'
const  model = new Model()
import Table2Excel  from 'table2excel.js';  

export default {
  data () {
    return {
      term : null,
      fm:{jilid_id:null,surveyor_id:null, type:1, alamat:false},
      sebaran:{idpro:null, idkec:null, idkab:null, idkel:null},
      disabled:{idpro:null, idkec:null, idkab:null, idkel:null},
      provinsi:[], provinsiLoading:false,
      jilidLoading:false, color:null,
      kabupaten:[], kabupatenLoading:false,
      kecamatan:[], kecamatanLoading:false,    
      kelurahan:[], kelurahanLoading:false,      
      surveyors:[], surveyorLoading:false,
      jilids:[], jilidLoading:false,   
      surveyorLoading : false,
      jilid : {}, 
      items: [],               
      loading: false,   
      user : {},   
      firstime : true,
      place : null,
      persen:0, loadstart:false,    
    }
  },
  computed:{
    status(){
      return this.$store.getters.DICTIONS.JilidStatus;      
    },    
  },
  watch:{
    'sebaran.idpro'(newId){if(newId){      
      model.node({id:newId,surveyor_id:this.fm.surveyor_id,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(res=>{this.provinsi.push(res)});
      this.kabupatenLoading = true; //this.fm.addr_idkab = null;
      model.kabupaten({parent:newId,surveyor_id:this.fm.surveyor_id,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(data=>{
        this.kabupaten=data; this.kabupatenLoading = false;  
        this.sebaran.idkab = this.sebaran.idkab && data.find(x=>x.id === this.sebaran.idkab) ? this.sebaran.idkab : null;         
      })
      if(!this.firstime){
        this.readItems();                 
      } 
    }},
    'sebaran.idkab'(newId){
      if(newId){      
        this.kecamatanLoading = true;
        model.kecamatan({parent:newId,surveyor_id:this.fm.surveyor_id,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(data=>{
          this.kecamatan=data; this.kecamatanLoading = false;
          this.sebaran.idkec = this.sebaran.idkec && data.find(x=>x.id===this.sebaran.idkec) ? this.sebaran.idkec:null;            
        })
        model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(data=>{this.sebaran.idpro = data.parent_id;})        
      } else {
        this.sebaran.idkec = null; this.kecamatan = []; 
      }
      if(!this.firstime){
        this.readItems();                 
      } 
    },
    'sebaran.idkec'(newId){
      if(newId){      
        this.kelurahanLoading = true; 
        model.kelurahan({parent:newId,jilid_id:this.jilid.id,surveyor_id:this.fm.surveyor_id,expand:'lembar,lembarDone'}).then(data=>{
          this.kelurahan=data; this.kelurahanLoading = false;
          this.sebaran.idkel = this.sebaran.idkel && data.find(x=>x.id===this.sebaran.idkel) ? this.sebaran.idkel : null;           
        });                
      } else {
        this.sebaran.idkel = null;
      }
      if(!this.firstime){
        this.readItems();                 
      }
    },
    'sebaran.idkel'(newId){
      if(!this.firstime){
        this.readItems();                 
      }       
    },
    'fm.jilid_id'(newId){
      if(this.fm.surveyor_id && newId){
        this.readItems();  
        this.surveyLoading = true;
        model.jilid({id:newId}).then(data=>{
          this.jilid=data;
          this.init();            
        })             
      }   
    },
    'fm.surveyor_id'(newId){ this.fm.jilid_id = null;
      this.user = this.surveyors.find(x=>x.id==newId);
      if(this.user){

        if(Array.isArray(this.user.jilids)){
          this.jilids = this.user.jilids;
           if(this.fm.surveyor_id && this.fm.jilid_id){
            this.readItems();  
            this.surveyLoading = true;
            model.jilid({id:this.fm.jilid_id}).then(data=>{
              this.jilid=data;
              this.init();            
            })             
          }   
        }            
      }
    }    
  },  
  mounted(){
    this.loading = true;
    model.jilids({}).then(res=>{
      this.jilids = res.data;
      if(this.$route.query.id){
        this.fm.jilid_id = this.$route.query.id;
      } else if(this.jilids[0]){
        //this.fm.jilid_id = this.jilids[0].id;
      }      
      this.loading = false;      
    });    
  },
  methods: {
    init(){
      if(this.jilid.node_id){
        this.color = this.$color();
        model.node({id:this.jilid.node_id,jilid_id:this.jilid.id,surveyor_id:this.fm.surveyor_id,expand:'lembar,lembarDone'}).then(res=>{
          if(res.level){
            this.disabled.addr_idpro = false;
            this.disabled.addr_idkab = false;
            this.disabled.addr_idkec = false;
            this.disabled.addr_idkel = false;
            this.sebaran.addr_idpro = null;
            this.sebaran.addr_idkab = null;
            this.sebaran.addr_idkec = null;
            this.sebaran.addr_idkel = null;
            switch(parseInt(res.level)){
              case 1: this.sebaran.idpro = res.id; 
                this.disabled.idpro = true;
                break;
              case 2: this.sebaran.idkab = res.id; 
                this.disabled.idpro = true;
                this.disabled.idkab = true;
                break;
              case 3: this.sebaran.idkec = res.id; 
                this.disabled.idpro = true;
                this.disabled.idkab = true;
                this.disabled.idkec = true;
                break;
              case 4: this.sebaran.idkel = res.id; 
                this.disabled.idpro = true;
                this.disabled.idkab = true;
                this.disabled.idkec = true;
                this.disabled.idkel = true;
                break;               
            }
            this.surveyLoading = false; 
            this.firstime = false;
          }            
        })
      }      
    },

    searchSurveyor: debounce(function(e){
      this.surveyorLoading = true;
      model.users({q:e.target.value, expand:'thumbFileBase64,nodes,jilids'}).then(res=>{
        this.surveyors = res.data;
        this.surveyorLoading = false;
      });
    }, 400),

    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 400),

    firstLetter (name) {
      return name? name.charAt(0): null;
    },  

    readItems () {
      this.loading = true      
      this.loadstart = true 
      
      const params = {        
        q: this.term,        
        jilid_id:this.fm.jilid_id,
        surveyor_id:this.fm.surveyor_id,
        idpro:this.sebaran.idpro,
        idkab:this.sebaran.idkab,
        idkec:this.sebaran.idkec,
        idkel:this.sebaran.idkel,
        expand:'responDtls, propinsi, kabupaten, kecamatan, kelurahan, tps'
      }

      this.persen = 0;
      model.surveys(params).then(async response => {
          response.data.forEach(item=>{
            if(item.geom)
            item.geom = JSON.parse(item.geom);
            if(item.geom && item.geom.coordinates && item.geom.coordinates[0]){
              this.place = {lat:parseFloat(item.geom.coordinates[0]), lng:parseFloat(item.geom.coordinates[1])};            
            }            
          });          
          
          this.items = response.data;
          this.loading = false 
          let totalPage   = response.pagination ? response.pagination.pageCount : 1;          
          this.persen = 1/parseInt(totalPage)*100;
          for (var i=2; i<=parseInt(totalPage); i++){
            //this.loading = true
            await model.surveys({...params, ...{page:i}}).then(response => {
              response.data.forEach(item=>{
                if(item.geom)
                item.geom = JSON.parse(item.geom);
                if(item.geom && item.geom.coordinates && item.geom.coordinates[0]){
                  this.place = {lat:parseFloat(item.geom.coordinates[0]), lng:parseFloat(item.geom.coordinates[1])};            
                }            
              });
              this.items = [...this.items,...response.data];               
              //this.loading = false                                          
            });
            this.persen = i/parseInt(totalPage)*100;
          }    
          this.loadstart = false       
        })
    }, 
    
    export2excel(){
      if(this.items.length !== 0){
        var filename = 'Report.';
        filename    += this.jilids.find(x=>x.id===this.fm.jilid_id) ? this.jilids.find(x=>x.id===this.fm.jilid_id).name+'.' : '';           
        filename    += this.$moment().format('DDMMYY.HHmm');
        new Table2Excel('#export table').export(filename);
      } else {
        window.getApp.$emit('showSnackbar', {
            show : true,
            text : 'No Data Result',
            color: 'orange'
        });
      }
    },
  },  
}
</script>
<style>
.tb-normal{    
  border-collapse: collapse;
}
.tb-normal td, .tb-normal th {
  border: 1px solid #ddd;
  padding: 4px 6px;
}
</style>